var styles = {"tend-ui-form-root":"tend-ui-form-root"};

export { styles as default };
//# sourceMappingURL=Form.module.css.js.map
